__turbopack_context__.v({
  "icon": "a-list-item-module__P-Cbda__icon",
  "item": "a-list-item-module__P-Cbda__item",
  "paired-item": "a-list-item-module__P-Cbda__paired-item",
  "paired-item-dotted-line": "a-list-item-module__P-Cbda__paired-item-dotted-line",
  "small-margin-top": "a-list-item-module__P-Cbda__small-margin-top",
});
